export const tr = {
    'and-more-links': '{moreLinksCount} daha',
    'filter-by-banner': '{banner} nolu reklamın kayıtlarını göster',
    'filter-by-cid': '{cid} nolu kampanyanın kayıtlarını göster',
    'filter-by-group': '{group} nolu grubun kayıtlarını göster',
    'open-banner': '{banner} nolu reklama git',
    'open-campaign': '{cid} nolu kampanyaya git',
    'open-group': '{group} nolu gruba git'
};
